import axios from 'axios';
import AccessManager from '../Utilities/AccessManager';

export default class DataLayer {

    constructor() {
        let appSettings = require('../appsettings.json');
        this.serverEndpoint = '';
        this.payFlexApiBase = '';

        //Set server API endpoint
        switch (appSettings.Environment) {
            case 'Test':
                this.serverEndpoint = appSettings.TestServerEndpoint;
                this.payFlexApiBase = 'https://api.uat.payflex.co.za/'
                break;
            case 'Production':
                this.serverEndpoint = appSettings.ProductionServerEndpoint;
                this.payFlexApiBase = 'https://api.payflex.co.za/'
                break;
            case 'Dev':
                this.serverEndpoint = appSettings.DevServerEndpoint;
                this.payFlexApiBase = 'https://api.uat.payflex.co.za/'
                break;
            default:
                break;
        }

        this.accessManager = new AccessManager();
    }

    async VerifyAccountDetails(accountDetails, token) {
        try {
            let response = await axios.post('https://api.bitventure.co.za/avs/', JSON.stringify(accountDetails), this.SetAccountVerificationHeaders(token));
            return response.data;

        } catch (exception) {
            alert('Error :' + exception)
        }
    }

    SetAccountVerificationHeaders(token) {
        return {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + token
            }
        }
    }

    async PlacePayflexOrder(data, token) {
        
        let response = await axios.post(`${this.payFlexApiBase}order/`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + token
            }
        });
        return response;
        
    }

    async GetPayflexConfig(token) {

        let response = await axios.get(`${this.payFlexApiBase}configuration/`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + token
            }
        });
        return response;

    }


    async GetVerificationToken() {
        let data = {
            "client_id": '9e302abb-8050-4796-af4d-8c2f22319c73',
            "client_secret": 'cfd2801e-5657-4166-983c-91704763c535',
            "scope": "account-verification-api",
            "grant_type": "client_credentials"
        };
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data ',
        }
        axios.post('https://api.bitventure.co.za/auth/connect/token', data, headers)
            .then(function (res) {
                console.log(res);
                return res;
            })
            .catch(error => {
                console.log(error)
            })

    }

    async PublicGet(path) {
        try {
            let response = await axios.get(`${this.serverEndpoint}${path}`, this.SetPublicHeaders());
            return this.HandleResponse(response, true);

        } catch (exception) {
            this.HandleError(exception);
        }
    }

    async Get(path, fromCart) {
        if (fromCart === undefined) {
            fromCart = false;
        }
        try {
            let response = await axios.get(`${this.serverEndpoint}${path}`, this.SetHeaders());
            return this.HandleResponse(response, fromCart, path);

        } catch (exception) {
            //this.HandleError(exception, handleErrorMsg, fromCart, object, path);
            this.HandleError(exception, undefined, fromCart, undefined, path);
        }
    }

    async PublicPost(path, object, handleErrorMsg) {
        if (handleErrorMsg === undefined) {
            handleErrorMsg = true;
        }
        try {
            let response = await axios.post(`${this.serverEndpoint}${path}`, JSON.stringify(object), this.SetPublicHeaders());
            return this.HandleResponse(response, handleErrorMsg);

        } catch (exception) {
            this.HandleError(exception, handleErrorMsg);
        }
    }

    async Post(path, object, handleErrorMsg, fromCart, catchMe) {
        if (catchMe !== undefined) {
            if (catchMe) {
                var test = '';
                if (object !== undefined) {
                    test = JSON.stringify(object);
                }
                var skdjsjkjdk = "";
            }
        }
        if (handleErrorMsg === undefined) {
            handleErrorMsg = true;
        }
        if (fromCart === undefined) {
            fromCart = false;
        }
        try {
            let response = await axios.post(`${this.serverEndpoint}${path}`, JSON.stringify(object), this.SetHeaders());
            return this.HandleResponse(response, handleErrorMsg, fromCart, object, path);

        } catch (exception) {
            this.HandleError(exception, handleErrorMsg, fromCart, object, path);
        }
    }

    async Put(path, object) {
        try {
            let response = await axios.put(`${this.serverEndpoint}${path}`, JSON.stringify(object), this.SetHeaders());
            return this.HandleResponse(response);
        } catch (exception) {
            this.HandleError(exception);
        }
    }

    async ResetPin(object) {
        let result = false;
        try {
            let response = await axios.post(`${this.serverEndpoint}/pin/resetpin`, JSON.stringify(object), {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            result = response;
        } catch (exception) {
            alert(`An error occurred. ${exception}`);
        } finally {
            return result;
        }
    }

    async Login(object) {
        let result = false;
        try {
            let response = await axios.post(`${this.serverEndpoint}/login`, JSON.stringify(object), {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            let handledResponse = this.HandleResponse(response);
            //console.log(handledResponse);

            if (handledResponse != null) {
                if (handledResponse.errorOccurred) {
                    result = false;
                    alert('An error occurred logging in, please check cell number and pin.');
                } else {
                    localStorage.setItem("TMAUser", JSON.stringify(handledResponse));
                    result = true;
                }
            }
        } catch (exception) {
            alert(`An error occurred. ${exception}`);
        } finally {
            return result;
        }
    }

    SetPublicHeaders() {
        return {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }
    }

    SetHeaders() {
        return {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + this.GetToken()
            }
        }
    }

    async PostErr(path, errorDetail) {
        
        try {
            let response = await axios.post(`${this.serverEndpoint}${path}`, JSON.stringify(errorDetail), this.SetHeaders());
            //return this.HandleResponse(response, handleErrorMsg, fromCart, object);

        } catch (exception) {
            //this.HandleError(exception, handleErrorMsg, fromCart, object);
        }
    }

    postTheError(endPointError, errorDetail, originMessage) {
        errorDetail = "EndPointOfError: " + endPointError + ", Object Sent: " + errorDetail + "Original Msg: " + originMessage;

        var to_replace= "/";
        var  replacement = "-";
        var required_string = errorDetail.replaceAll(to_replace, replacement);

        let requestObject = {
            ErrorDetail: required_string
        }
        this.PostErr("/cart/logCartError", requestObject);
    }

    HandleResponse(response, handleErrorMsg, fromCart, object, path) {
        if (response.data.errorOccurred) {
            if (handleErrorMsg) {
                alert(`An error occurred. ${response.data.errorMessage}`);
            }
            if (fromCart) {
                var test = '';
                if (object !== undefined) {
                    test = JSON.stringify(object);
                }
                var ksdjhskjdk = "";
                this.postTheError(path, test, response.data.errorMessage);
            }
            return response.data;
        }
        else {
            return response.data;
        }
    }

    HandleError(exception, handleErrorMsg, fromCart, object, path) {
        try {
            if (exception.response.status === 401) {
                alert(`Your session has expired, please login.`);
                this.accessManager.logout();
            }
            else {
                if (handleErrorMsg) {
                    alert(`An error occurred. ${exception}`);
                }
                if (fromCart) {
                    //this.Post("/common/checkout", requestObject, true, 1);
                    var test = '';
                    if (object !== undefined) {
                        test = JSON.stringify(object);
                    }
                    var skdjsjkjdk = "";
                    this.postTheError(path, test, exception);
                }
            }
        } catch (exception) {
            if (handleErrorMsg) {
                alert(`An error occurred. ${exception}`);
            }
            if (fromCart) {
                //this.Post("/common/checkout", requestObject, true, 1);
                var test = '';
                if (object !== undefined) {
                    test = JSON.stringify(object);
                }
                var skdjsjkjdk = "";
                this.postTheError(path, test, exception);
            }
        }
    }

    GetToken() {
        return JSON.parse(localStorage.getItem("TMAUser")).data.token;
    }
}